<template>
	<record-preview :docId="docId" id='record-print-preview'   v-if="visible"/>
</template>

<script>
	import RecordPreview from '@/views/record/record-preview.vue'
	import RecordMixin from '@/views/record/record-mixin'
	import Print from '@/js/printarea'
	// import html2pdf from 'html2pdf.js'
	export default {
		components: { RecordPreview },
		mixins: [RecordMixin],

		data() {
			return {
				visible: false,
				docId: null,
				printObj: {
					ids: 'record-print-preview',
					beforeOpenCallback: () => { },
					openCallback: () => { },
					closeCallback: () => {
						this.visible = false
					}
				}
			}
		},
		methods: {
			open(docId) {
				this.visible = true
				this.docId = docId

			},
			// 需要解决问题 ‘如何判断页面已经加载完成了’
			print(docId) {
				this.visible = true
				this.docId = docId
				this.$msgbox({
					title: '等待提示',
					showConfirmButton: false,
					showCancelButton: false,
					showClose: false,
					closeOnClickModal: false,
					message: <div style="width:100%;"><i class="el-icon-loading" style="margin-right:10px" />正在准备打印信息...</div>
				})
				setTimeout(() => {
					this.$msgbox.close()
					new Print(this.printObj)

				}, 500)


			},
			exportPdf(){
				// var ele = document.getElementById('record-preview')
				// 	console.log('ele=', ele)
				// 	// ele.style.display='block'
				// 	html2pdf().set({
				// 		margin: 1,
				// 		filename: 'myfile.pdf',
				// 		image: { type: 'jpeg', quality: 0.98 },
				// 		html2canvas: { scale: 2 },
				// 		jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
				// 	}).from(ele).save().catch(e=>console.log(e))
			}
		}
	}
</script>

<style lang="scss" scoped>
	#record-print-preview {
		// position: fixed;
		// height: auto;
		display:none;
	}
</style>


// WEBPACK FOOTER //
// src/views/record/record-print.vue